// extracted by mini-css-extract-plugin
export default {"inviteesListPage":"InviteesList_inviteesListPage__hnbZK","table":"InviteesList_table__VuzEm"};